export default __webpack_public_path__ + "img/ed4fdfbe356b2576e2cfa4136e361c32.svg";